import {
	briefTemplatesList,
	briefTemplateById,
	createBriefTemplate,
	updateBriefTemplate,
	deleteBriefTemplate,
	briefSuggestionsList,
	briefSuggestionById,
	currentBriefSuggestion,
	selectBriefs,
	generateBriefSuggestions,
	enrichBriefs,
	publishBriefTemplate,
	rewriteBriefTemplate,
	rejectBriefTemplate,
	createEditorialDraft,
} from '@/services/content-briefs.service'

export default {
	namespaced: true,
	state: {
		templatesList: {
			meta: { pagination: { total: 0 } },
		},
		template: {},
		suggestionsList: {
			meta: { pagination: { total: 0 } },
		},
		suggestion: {},
		currentSuggestion: null,
		pendingDraftsList: {
			meta: { pagination: { total: 0 } },
		},
		status: 'init',
		saveStatus: 'init',
		deleteStatus: 'init',
		draftActionStatus: 'init',
	},
	getters: {
		getTemplatesList: state => state.templatesList,
		getTemplate: state => state.template,
		getSuggestionsList: state => state.suggestionsList,
		getSuggestion: state => state.suggestion,
		getCurrentSuggestion: state => state.currentSuggestion,
		getPendingDraftsList: state => state.pendingDraftsList,
		getStatus: state => state.status,
		getSaveStatus: state => state.saveStatus,
		getDeleteStatus: state => state.deleteStatus,
		getDraftActionStatus: state => state.draftActionStatus,
	},
	mutations: {
		SET_TEMPLATES_LIST(state, val) { state.templatesList = val },
		SET_TEMPLATE(state, val) { state.template = val },
		SET_SUGGESTIONS_LIST(state, val) { state.suggestionsList = val },
		SET_SUGGESTION(state, val) { state.suggestion = val },
		SET_CURRENT_SUGGESTION(state, val) { state.currentSuggestion = val },
		SET_PENDING_DRAFTS_LIST(state, val) { state.pendingDraftsList = val },
		SET_STATUS(state, val) { state.status = val },
		SET_SAVE_STATUS(state, val) { state.saveStatus = val },
		SET_DELETE_STATUS(state, val) { state.deleteStatus = val },
		SET_DRAFT_ACTION_STATUS(state, val) { state.draftActionStatus = val },
	},
	actions: {
		// TEMPLATES
		async fetchTemplatesList({ commit }, params) {
			commit('SET_STATUS', 'pending')
			try {
				const { data } = await briefTemplatesList(params)
				commit('SET_TEMPLATES_LIST', data)
				commit('SET_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATUS', 'init')
				throw error
			}
		},
		async fetchTemplateById({ commit }, id) {
			commit('SET_STATUS', 'pending')
			try {
				const { data } = await briefTemplateById(id)
				commit('SET_TEMPLATE', data.data)
				commit('SET_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATUS', 'init')
				throw error
			}
		},
		async saveTemplate({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id
					? await updateBriefTemplate(params)
					: await createBriefTemplate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteTemplate({ commit }, id) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				const { data } = await deleteBriefTemplate(id)
				commit('SET_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_DELETE_STATUS', 'init')
				throw error
			}
		},

		// SUGGESTIONS
		async fetchSuggestionsList({ commit }, params) {
			commit('SET_STATUS', 'pending')
			try {
				const { data } = await briefSuggestionsList(params)
				commit('SET_SUGGESTIONS_LIST', data)
				commit('SET_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATUS', 'init')
				throw error
			}
		},
		async fetchSuggestionById({ commit }, id) {
			commit('SET_STATUS', 'pending')
			try {
				const { data } = await briefSuggestionById(id)
				commit('SET_SUGGESTION', data.data)
				commit('SET_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATUS', 'init')
				throw error
			}
		},
		async fetchCurrentSuggestion({ commit }) {
			commit('SET_STATUS', 'pending')
			try {
				const { data } = await currentBriefSuggestion()
				commit('SET_CURRENT_SUGGESTION', data.data || null)
				commit('SET_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATUS', 'init')
				throw error
			}
		},
		async selectBriefs({ commit }, { id, selectedBriefs }) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = await selectBriefs(id, { selected_briefs: selectedBriefs })
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SAVE_STATUS', 'init')
				throw error
			}
		},
		async generateSuggestions({ commit }) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = await generateBriefSuggestions()
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SAVE_STATUS', 'init')
				throw error
			}
		},
		async enrichWithAI({ commit }, params) {
			try {
				const { data } = await enrichBriefs(params)
				return data
			} catch (error) {
				throw error
			}
		},

		// PENDING DRAFTS (institutional blog AI generation review)
		async fetchPendingDraftsList({ commit }, params) {
			commit('SET_STATUS', 'pending')
			try {
				const { data } = await briefTemplatesList(params)
				commit('SET_PENDING_DRAFTS_LIST', data)
				commit('SET_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATUS', 'init')
				throw error
			}
		},
		async publishTemplate({ commit }, id) {
			commit('SET_DRAFT_ACTION_STATUS', 'pending')
			try {
				const { data } = await publishBriefTemplate(id)
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				throw error
			}
		},
		async rewriteTemplate({ commit }, id) {
			commit('SET_DRAFT_ACTION_STATUS', 'pending')
			try {
				const { data } = await rewriteBriefTemplate(id)
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				throw error
			}
		},
		async createEditorialDraft({ commit }, params) {
			commit('SET_DRAFT_ACTION_STATUS', 'pending')
			try {
				const { data } = await createEditorialDraft(params)
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				throw error
			}
		},
		async rejectTemplate({ commit }, id) {
			commit('SET_DRAFT_ACTION_STATUS', 'pending')
			try {
				const { data } = await rejectBriefTemplate(id)
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_DRAFT_ACTION_STATUS', 'init')
				throw error
			}
		},
	},
}
